module.exports = __webpack_public_path__ + "media/images/donation-screenshot-v2-59f0584ccd1e8da5b631bb7a9c26e5ad.png";